export default __webpack_public_path__ + "static/media/7minfitness@2x.4177518b.jpg";